import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=6949a058&scoped=true&"
import script from "./myPrize.vue?vue&type=script&lang=js&"
export * from "./myPrize.vue?vue&type=script&lang=js&"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=6949a058&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6949a058",
  null
  
)

export default component.exports